import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import toast from "components/Toast/toast";
import { notifications } from "service/apiUrl";
import { API } from "service/Interceptor";
import { acceptOrRejectEmailRequest } from "./requestEmailSlice";

const initialState = {
  notifications: [],
  notificationCount: 0,
  hasError: false,
  isLoading: false,
};

export const getAllNotifications = createAsyncThunk(
  "get-all-notifications",
  async (params, thunkAPI) => {
    // console.log(params);
    try {
      const res = await API.get(notifications, { params });
      if (res?.data?.success) {
        return res?.data?.data?.results || [];
      } else {
        // console.log(res?.data?.message || "Error in getting notifications");
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in getting notifications"
        );
      }
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(
        "Something went wrong in getting notifications"
      );
    }
  }
);

export const readNotifications = createAsyncThunk(
  "read-notifications",
  async (arr) => {
    try {
      const payload = {
        notificationIds: arr,
      };
      const res = await API.put(notifications, payload);
      if (res?.data?.success) {
        return { arr, result: res?.data?.data };
      }
    } catch (error) {
      console.log(error);
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        // console.log(action.payload);
        // console.log(state.notifications);
        state.notifications = action.payload;
        state.notificationCount = action.payload.length;
      })
      .addCase(getAllNotifications.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })

      //------------------READING NOTIFICATIONS ----------------
      .addCase(readNotifications.pending, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(readNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.notifications = state.notifications.map((notification) => {
          return { ...notification, isRead: true };
        });
      })
      .addCase(readNotifications.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })

      //----------- TO DISABLE ACCEPT AND REJECT BUTTON OF NOTIFICATIONS ----------
      .addCase(acceptOrRejectEmailRequest.fulfilled, (state, action) => {
        const { userAliasId } = action.payload;
        const index = state.notifications.findIndex((item) => {
          return (
            item.actionUserDto?.actionUserAliasId === userAliasId &&
            item.actiontype === "CONNECT"
          );
        });
        state.notifications[index].connectionStatus = "ACCEPT";
      });
  },
});

export default notificationSlice.reducer;
